import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert, Typography, Button } from "@mui/material";
import axios from "axios";
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import Select from "@mui/material/Select";
//import Option from "@mui/material/Option";
//import Button from '@material-ui/core/Button';
//import Envios from "./Envios";
//import SearchBar from "./SearchBar"
//import DatePicker from "react-datepicker";
//import "../search.css";
//import "../stylesheets/datepicker-cssmodules.scss"
//import "react-datepicker/dist/react-datepicker.css";

//const Dashboard = () => {  
function Dashboard() {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const username = userData?.username;
  const clienteid = userData?.clienteid;
  const empresaid = userData?.empresaid;
  const imagen_cliente = userData?.imagen_cliente;
  const tipocuenta = userData?.tipocuenta; 
  const [apiResponse, setApiResponse] = useState("");
  const [apiResponseEmp, setApiResponseEmp] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [empresa, setEmpresa] = useState([]);
  const [apiResponse2, setApiResponse2] = useState("");
  const [pedidos2, setPedidos2] = useState([]);
  //const Total2 =  useState([]);
  const [Total, setApiResponse3] = useState("");
  const [Listo_Para_Enviar, setApiResponse4] = useState("");
  const [En_Transito, setApiResponse5] = useState("");
  const [Entregado, setApiResponse6] = useState("");
  const [No_Entregado, setApiResponse7] = useState("");
  const [height, setHeight] = useState(0)
  const ref = useRef(null)
  ///const [startDate, setStartDate] = useState(new Date());
  //const [monthDate, setMonthDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(new Date());
  const [postDate, setPostDate] = useState("");
  const [postEmp, setPostEmp] = useState("");
  const [postMes, setPostMes] = useState((fromDate.getMonth()+1).toString().padStart(2, "0"));
  const [postSearch, setPostSearch] = useState("");

  const meses = [
    {
      value: '01',
      label: 'Enero',
    },
    {
      value: '02',
      label: 'Febrero',
    },
    {
      value: '03',
      label: 'Marzo',
    },
    {
      value: '04',
      label: 'Abril',
    },
    {
      value: '05',
      label: 'Mayo',
    },
    {
      value: '06',
      label: 'Junio',
    },
    {
      value: '07',
      label: 'Julio',
    },
    {
      value: '08',
      label: 'Agosto',
    },
    {
      value: '09',
      label: 'Septiembre',
    },
    {
      value: '10',
      label: 'Octubre',
    },
    {
      value: '11',
      label: 'Noviembre',
    },
    {
      value: '12',
      label: 'Diciembre',
    },
  ];

  /*
  function getEmpresas() {
    axios
    .post("https://boxerlogistica.com/api/getEmpresas.php", {
      empresaid: empresaid
    })
    .then(function(response3){
      //const empresa = response3.data.data;
      //console.log(response3.data.data);
      setApiResponseEmp(response3.data.message);
      setEmpresa(response3.data.data); 
    }); 
  }
*/
  const handleSubmit = (event) => {
      event.preventDefault()

      // log form content
      //console.log(postEmp)
      //console.log(postMes)
      //console.log(postSearch)
      //console.log(postDate)
      

      axios
     .post("https://boxerlogistica.com/api/enviosItalika.php", {
       clienteid: clienteid, tipocuenta: tipocuenta, postDate: postDate, postMes: postMes, postSearch: postSearch, postEmp: postEmp

     })
     .then(function(response){
      // console.log(response.data);
       setApiResponse(response.data.message);
       setPedidos(response.data.data);

     }); 
  }

  
  const handleImprimir = (event, message) => {
    
    //console.log(event.target);

    //console.log(message);

    //console.log('Image clicked');
    sessionStorage.setItem("seguimientoIDActual", '');
    sessionStorage.setItem("seguimientoIDActual", message);
    window.location.href = "/GuiaImprimir";
      
}


  const handleClearForm = (event) => {
    event.preventDefault()

    // log form content
    
    //console.log(postEmp)
    //console.log(postMes)
    //console.log(postSearch)
    //console.log(postDate)

    
  setPostDate("");
  setPostEmp('0');
  setPostMes('0');
  setPostSearch("");

  }

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("loggedIn");

    setHeight(ref.current.clientHeight)
       
    if (!loggedIn) {
      navigate("/login");
    }else{
      getPedidos();
      getPedidos2();
      //getEmpresas();
    }
  }, [navigate]);


  function getPedidos() {
    const inicio = 20;
     axios
     .post("https://boxerlogistica.com/api/enviosItalika.php", {
       clienteid: clienteid, tipocuenta: tipocuenta, inicio: inicio

     })
     .then(function(response){
      // console.log(response.data);
       setApiResponse(response.data.message);
       setPedidos(response.data.data);
     }); 
 }

 function getPedidos2() {
  axios
  .post("https://boxerlogistica.com/api/envios2Italika.php", {
    clienteid: clienteid, tipocuenta: tipocuenta
  })
  .then(function(response2){
    //console.log(response2.data);
    setApiResponse2(response2.data.message);
    setPedidos2(response2.data.data);
    sessionStorage.setItem("PedidoData", JSON.stringify(response2.data.data));
    const PedidoData = JSON.parse(sessionStorage.getItem("PedidoData"));
    setApiResponse3(PedidoData?.Total);
    setApiResponse4(PedidoData?.Listo_Para_Enviar);
    setApiResponse5(PedidoData?.En_Transito);
    setApiResponse6(PedidoData?.Entregado);
    setApiResponse7(PedidoData?.No_Entregado);
  }); 
}

//Pagination Start
  //const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);

   // Get current items
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const pedidoi = pedidos.slice(indexOfFirstItem, indexOfLastItem);

   //console.log('indexOfLastItem',indexOfLastItem);
   //console.log('indexOfFirstItem',indexOfFirstItem);
   //console.log('>> formData >> ',pedidoi);
 
   // Change page
   const paginate = (pageNumber) => setCurrentPage(pageNumber);
   
   //console.log('>> paginate >> ',paginate);
//Pagination End


  return (
    
    <Container>
      
      <div>
          <div className="Dashboard-container" height="300px" ref={ref}>
              <div className="div-left_Dashboard">
                <ul className="footer">
                  <li color="#ea7004">
                    <table>
                      <tbody>
                      <tr><td align="center"><img src={"/images/clientes/" + imagen_cliente} alt="Cliente" class="img_Dashboard"></img>
                      <br></br>
                      <span className="dashboard_user">{username}</span>
                      </td></tr>
                      <tr><td><br></br></td></tr>
                      <tr><td align="center">
                            <span>&nbsp;</span> 
                      </td></tr>
                      </tbody>
                    </table>
                  </li>
                </ul>
              </div>
              <div className="div-right_Dasboard">
                        <div >
                        <Typography variant="h4" gutterBottom>
                                  Bienvenido, {username}!
                            </Typography>
                            <br />  
                              <ul className="footer">        
                                <li>
                                  <div className="box">
                                    <span className="menu1">ENVIOS TOTALES</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu1_value">{Total}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu2">RECOLECTADO</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu2_value">{Listo_Para_Enviar}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu3">RUTA</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu3_value">{En_Transito}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu4">ENTREGADO</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu4_value">{Entregado}</span>
                                  </div>
                                </li>
                                <li>
                                  <div className="box">
                                    <span className="menu5">NO ENTREGADO</span>
                                    <br></br>
                                    <br></br>
                                    <span className="menu5_value">{No_Entregado}</span>
                                  </div>
                                </li>
                                </ul>
                            
                        </div>
            
                <br></br>
                <br></br>
                        <div className="box_env">
                        <form id="external-form" onSubmit={handleSubmit}>
                          <table float="center" >
                          <tbody>
                              <tr>
                              <td>
                              <div className="form-group">
                              &nbsp;&nbsp;
                                </div>
                                </td>
                              <td>
                                  <div className="form-group">
                                  <TextField
                                    type="text"
                                    value={postDate}
                                    onChange={event => setPostDate(event.target.value)}
                                    variant="outlined"
                                    id="postDate"
                                    label="DD/MM/YYYY"
                                    size="small"
                                    fullWidth
                                  />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-group">
                                  <TextField
                                    type="text"
                                    value={postSearch}
                                    onChange={event => setPostSearch(event.target.value)}
                                    variant="outlined"
                                    id="postSearch"
                                    label="Buscar Guia"
                                    size="small"
                                    fullWidth
                                  />
                                  </div>
                                </td>
                                
                                <td>
                                    <button type="submit" className="submitBtn">Buscar</button>
                                    
                                </td>
                              </tr>
                              <tr><td colSpan="4" align="right"><Button onClick={handleClearForm}>Borrar Filtros</Button></td></tr>
                              </tbody>
                            </table>
                            </form>
                          </div>
                <br></br>
                <br></br>
                </div>
                        <div className="box_env2">
                        <table float="left" >
                            <tbody>
                            <tr >
                              <td align="left" float="left">
                              <div class="table-responsive">
                                <table class="table table-hover" id="job-table">
                                  <thead>                             
                                      <tr >
                                        <th width="15%">
                                        RECOLECCION
                                        </th>
                                        <th>    </th>
                                        <th width="30%">
                                        NOMBRE REMITENTE
                                        </th>
                                        <th>    </th>
                                        <th width="30%">
                                        NOMBRE DESTINO
                                        </th>
                                        <th>    </th>
                                        <th width="30%">
                                        REMISION
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        CAJA
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        PESO VOLUMÉTRICO
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        PESO
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        LARGO
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        ANCHO
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        ALTO
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        GUIA
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        ENTREGA
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        ESTATUS
                                        </th>
                                        <th>   </th>
                                        <th width="15%">
                                        SERVICIO
                                        </th>
                                        <th>   </th>
                                        <th width="35%">
                                        RECIBE
                                        </th>
                                        <th>   </th>
                                        <th width="25%">
                                        PRECIO
                                        </th>
                                        <th>   </th>
                                        <th width="30%">
                                        EVIDENCIA    
                                        </th>
                                      </tr>
                                      <tr>
                                          <td colspan="32">
                                            <hr></hr>
                                          </td>
                                        </tr>
                                      </thead>
                                      <tbody class="text-center tableBody">
                            {pedidoi ? pedidoi.map((pedido, key) =>
                            <>
                                        <tr key={key}>
                                          <td>
                                              {pedido.FechaRecoleccion}
                                          </td>
                                          <td> </td>
                                          <td>
                                              {pedido.NombreRemitente}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.NombreAgenciaDestino}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Remision}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Caja}
                                          </td>
                                          <td></td>
                                          <td align="center">    
                                              {pedido.PesoVolumetrico}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Peso}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Largo}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Ancho}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Alto}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Guia}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.FechaEntrega}
                                          </td>
                                          <td></td>
                                          <td>
                                              {pedido.EstatusPaquete}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Servicio}
                                          </td>
                                          <td></td>
                                          <td>   
                                              {pedido.NombreRecibe}
                                          </td>
                                          <td></td>
                                          <td>    
                                              {pedido.Precio}
                                          </td>
                                          <td></td>
                                          <td>
                                          {pedido.ImagenEvidencia ? 
                                            <a className="a_evidencia" href={"https://boxerlogistica.com/api/upload/" + pedido.ImagenEvidencia} target="_blank" rel="noopener noreferrer">Ver Evidencia</a>
                                           : null }
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan="32">
                                            <hr></hr>
                                          </td>
                                        </tr></>  
                              ) : null } 
                                         </tbody>
                                        </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                          </table>
                          <div>
                                          <Pagination
                                              itemsPerPage={itemsPerPage}
                                              totalItems={pedidos.length}
                                              paginate={paginate}
                                              currentPage={currentPage}
                                            />
                            </div>
                        </div>
                           
          </div>    
      </div>
      <br></br>
      <br></br>
 </Container>
    
  );

  

}


const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

//<li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
// <button onClick={() => paginate(number)} className="page-link">
//<li key={number} className="Pag">
//<button onClick={() => paginate(number)} >

  return (
    <nav>
      <ul className="pagination">
        {pageNumbers.map(number => (
          
            
            <li key={number} className={`pagination ${currentPage === number ? 'active' : ''}`}>
            <button onClick={() => paginate(number)} className="pagination">
              {number}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Dashboard;
